import { ChangeDetectionStrategy, Component, ContentChild, EventEmitter, Inject, Input, Output } from '@angular/core';
import { CustomPopupContentDirective } from '../../directives/custom-popup-content.directive';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EmiPopupConfig } from '../../models/popup.models';

@Component({
  selector: 'emi-popup-footer',
  templateUrl: './popup-footer.component.html',
  styleUrls: ['./popup-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PopupFooterComponent {
  @Input() isLoading: boolean = false;

  @Output() primaryBtnClicked: EventEmitter<boolean> = new EventEmitter();

  @Output() secondaryBtnClicked: EventEmitter<boolean> = new EventEmitter();

  @ContentChild(CustomPopupContentDirective) protected customContent?: CustomPopupContentDirective;

  constructor(@Inject(MAT_DIALOG_DATA) public readonly config: EmiPopupConfig) {}
}
